/**
 * @desc 根据调拨单号集合查询po占用
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/outPlan/getPoOccupyByAoNoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
